/**
 * Case-Study Benchmark helpers (Q-03, Tim's Aug 25 message). Pure — no Firebase — so they are unit-testable.
 */
/** Library categories for the picker — Hugo_Documents.category (P5-13) first, then the case study's source. */
export const CASE_STUDY_CATEGORY_LABELS = Object.freeze({
  csb: 'Case studies (CSB)',
  incident: 'Incident reports',
  investigation: 'Investigation reports',
  causal_analysis: 'Causal analyses',
  audit: 'Audit reports',
  observation: 'Observation reports',
  regulatory: 'Regulatory reports',
  internal: 'Internal reports',
  other: 'Other documents',
});
export const CASE_STUDY_CATEGORY_ORDER = Object.keys(CASE_STUDY_CATEGORY_LABELS);

export function caseStudyCategory(c) {
  const k = c?.category || c?.source || 'other';
  return CASE_STUDY_CATEGORY_LABELS[k] ? k : 'other';
}

/** Group visible case studies by category, in a fixed order, for the builder picker. */
export function groupCaseStudiesByCategory(list) {
  const groups = new Map();
  for (const c of list || []) {
    const k = caseStudyCategory(c);
    if (!groups.has(k)) groups.set(k, []);
    groups.get(k).push(c);
  }
  return CASE_STUDY_CATEGORY_ORDER.filter((k) => groups.has(k)).map((k) => ({ key: k, label: CASE_STUDY_CATEGORY_LABELS[k], items: groups.get(k) }));
}

/**
 * Compare the scope's REPS scores against one document's scores. Higher = worse
 * (OE), so a negative delta means the scope is doing better than the document.
 */
export function benchmarkDelta(scopeScores, docScores) {
  const out = {};
  for (const q of ['reliability', 'efficiency', 'productivity', 'safety']) {
    const a = scopeScores?.[q]; const b = docScores?.[q];
    out[q] = a != null && b != null ? Number((Number(a) - Number(b)).toFixed(1)) : null;
  }
  return out;
}
